import { Box, type MantineStyleProps, Text } from '@mantine/core'
import type { JSX, ReactNode } from 'react'

export function DataDisplay(
  props: MantineStyleProps & {
    value: ReactNode
    label?: string
    placeholder?: string
  }
): JSX.Element {
  return (
    <Box {...props}>
      {props.label && (
        <Text fz="sm" fw="bold">
          {props.label}
        </Text>
      )}
      {props.value ? props.value : <Text c="gray">{props.placeholder}</Text>}
    </Box>
  )
}
